import { lazy, Suspense } from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import styled from "styled-components";

import Footer from "../components/Footer";
import Header from "../components/Header";

import routes from "./config";
import GlobalStyles from "../globalStyles";

const AppWrapper = styled.div`
  min-height: 100vh;
  display: flex;
  flex-direction: column;
`;

const MainContent = styled.main`
  flex: 1;
  display: flex;
  flex-direction: column;
`;

const Router = () => {
  return (
    <Suspense fallback={null}>
      <GlobalStyles />
      <AppWrapper>
        <Header />
        <MainContent>
          <Routes>
            <Route path="/privacy" element={<Navigate to="/privacy_policy.html" replace />} />
            {/* Reroute home to MagicBricks for now */}
            {/* <Route path="/" element={<Navigate to="/home" replace />} /> */}
            {routes.flatMap((routeItem) => {
              const Component = lazy(() => import(`../pages/${routeItem.component}`));
              return routeItem.path.map((path) => (
                <Route
                  key={path}
                  path={path}
                  element={<Component />}
                />
              ));
            })}
          </Routes>
        </MainContent>
        <Footer />
      </AppWrapper>
    </Suspense>
  );
};

export default Router;
